import React from 'react'
import { Button, Stack } from '@the-game/components'
import {
    StyledInlineRegistrationContainer,
    StyledOr,
} from './inline-registration.styled'
import { useHistory, useLocation } from 'react-router-dom'
import { useUser } from '../authentication/UserContext'
import { setItem } from '../utils/local-storage'
import { useIsMobileView } from '@the-game/components/utils'
import { BoxBreakpointHide } from '@the-game/components/BoxBreakpointHide'
import { RegistrationButtons } from '../home/Home.styled'
import { environment } from '../../environments/environment'

interface Props {
    redirectPath?: Location
}

export function InlineRegistrationForm(props: Props) {
    const { redirectPath } = props
    const { userManager } = useUser()
    const location = useLocation()
    const history = useHistory()

    const isMobile = useIsMobileView()

    const onClickLogin = async () => {
        try {
            setRedirectPath()
            await userManager.signinRedirect({
                data: { url: location.pathname },
                prompt: 'select_account',
            })
        } catch (error) {
            console.error('signinRedirect failed', error)
        }
    }

    const setRedirectPath = () => {
        if (redirectPath) {
            setItem('redirect-path', redirectPath.pathname)
        }
    }

    async function onClickRegister() {
        setRedirectPath()
        if (environment.useAuth0) {
            await userManager.signinRedirect({
                data: { url: location.pathname },
                prompt: 'select_account',
                extraQueryParams: {
                    ...userManager.settings.extraQueryParams,
                    page_type: 'sign-up',
                },
            })
        } else {
            history.push('/register')
        }
    }

    return (
        <Stack direction="column" alignItems="stretch">
            <BoxBreakpointHide breakpointProp="lg" isReverse={true}>
                <Stack component="span" spacing="xl">
                    {/* Easy and FREE TO PLAY! Tip with The Game and win huge prizes */}
                    Sign up to compete for the ultimate bragging rights
                </Stack>
            </BoxBreakpointHide>

            <RegistrationButtons>
                <Stack
                    direction="column"
                    alignItems="center"
                    gap={isMobile ? 'md' : 'lg'}
                    spacing="xxxl"
                >
                    <Button
                        onClick={onClickRegister}
                        kind="primary"
                        fluid={true}
                        size="lg"
                    >
                        Sign up
                    </Button>
                    <StyledOr>
                        <hr />
                        <span>OR</span>
                        <hr />
                    </StyledOr>
                    <Button
                        onClick={onClickLogin}
                        kind="action"
                        fluid={true}
                        size="lg"
                    >
                        Log in
                    </Button>
                </Stack>
            </RegistrationButtons>
        </Stack>
    )
}

export function InlineRegistration(props: Props) {
    const { redirectPath } = props
    return (
        <StyledInlineRegistrationContainer component="section">
            <InlineRegistrationForm redirectPath={redirectPath} />
        </StyledInlineRegistrationContainer>
    )
}

export default InlineRegistration
